var _defs, _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldZakautChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gold",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 20.6,
    viewBox: "0 0 26 20.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: -0.247,
    x2: 2.617,
    y2: 2.341,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.235,
    y1: 1.594,
    x2: -0.8,
    y2: -0.186,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.309,
    y1: 0.609,
    x2: -0.863,
    y2: 1.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.025,
    y1: 1.508,
    x2: 1.356,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Shape",
    x: 0,
    y: 9.545,
    width: 26,
    height: 10.459,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M8.932,15.523H8.794c-1.851.132-4.418-1.467-6.6-4.044C-.587,8.194.067,3.114.067,3.114A14.178,14.178,0,0,1,5.66,4.737,14,14,0,0,1,8.862,0a13.969,13.969,0,0,1,3.206,4.737,14.177,14.177,0,0,1,5.593-1.622s.654,5.08-2.127,8.365c-2.1,2.477-4.552,4.051-6.385,4.051Q9.039,15.53,8.932,15.523Z",
    transform: "translate(4.136)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M3.8,10.779l-.114.006C1.462,10.671,0,7.244,0,3.029A8.5,8.5,0,0,1,.6,0,8.619,8.619,0,0,1,2.948,1.9q.456.539.851,1.087.394-.546.851-1.087A8.619,8.619,0,0,1,7,0a8.481,8.481,0,0,1,.6,3.029c0,4.215-1.462,7.642-3.687,7.756Z",
    transform: "translate(9.201 4.731)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.116,11.126.524,6.944C-.6,5.514.147,2.737,2.116,0,4.089,2.737,4.833,5.514,3.708,6.944Z",
    transform: "translate(10.882 7.719)",
    fill: "url(#linear-gradient-3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Shape)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M17.473,2.057C20.376.05,23.686-.482,26,.432a16.263,16.263,0,0,0-7.532,3.037A16.363,16.363,0,0,0,13.01,9.447l0,.012C12.921,6.974,14.569,4.062,17.473,2.057Zm-4.479,7.39A16.4,16.4,0,0,0,7.536,3.469,16.258,16.258,0,0,0,0,.432C2.319-.482,5.624.05,8.527,2.057s4.548,4.917,4.467,7.4Z",
    transform: "translate(0 9.54)",
    fill: "url(#linear-gradient-4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "check_2_",
    "data-name": "check (2)",
    transform: "translate(-2.796 6.836)",
    fill: "#40a87f",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.297168731689453 13.26319789886475 C 7.916539192199707 13.26320743560791 7.558689117431641 13.11495780944824 7.289519309997559 12.84575748443604 L 4.031894683837891 9.588132858276367 C 3.65552020072937 9.232726097106934 3.501396417617798 8.701563835144043 3.629619121551514 8.199497222900391 C 3.758619070053101 7.694367408752441 4.152549266815186 7.300437450408936 4.657679080963135 7.171427249908447 C 4.772889137268066 7.142007350921631 4.891519069671631 7.127087593078613 5.01025915145874 7.127087593078613 C 5.400872707366943 7.127087593078613 5.777734279632568 7.289575099945068 6.045909881591797 7.573276042938232 L 8.224364280700684 9.750693321228027 L 11.54623603820801 5.518257617950439 L 11.32729911804199 5.518257617950439 L 12.23164939880371 4.65611743927002 C 12.49779891967773 4.402747631072998 12.84673881530762 4.263197422027588 13.21417903900146 4.263197422027588 C 13.58976936340332 4.263197422027588 13.94423866271973 4.408067226409912 14.21228885650635 4.671117305755615 C 14.75910758972168 5.207699298858643 14.7861156463623 6.067827701568604 14.27711868286133 6.637341499328613 L 9.365598678588867 12.77981758117676 L 9.354068756103516 12.79423713684082 L 9.341508865356445 12.80776786804199 C 9.079548835754395 13.08991718292236 8.708529472351074 13.25582790374756 8.323578834533691 13.26294708251953 L 8.297168731689453 13.26319789886475 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.21417427062988 4.763197898864746 C 12.9847240447998 4.763197898864746 12.75514984130859 4.848089218139648 12.57640838623047 5.018257141113281 L 12.57764911651611 5.018257141113281 C 12.56892967224121 5.026827812194824 12.56068897247314 5.035887718200684 12.552978515625 5.045387268066406 L 8.269618988037109 10.50286674499512 L 5.687028884887695 7.921507835388184 C 5.456439018249512 7.674047470092773 5.109148025512695 7.572176933288574 4.78140926361084 7.655877113342285 C 4.453679084777832 7.739577293395996 4.197769165039062 7.995487213134766 4.114068984985352 8.323227882385254 C 4.030368804931641 8.650957107543945 4.132228851318359 8.998247146606445 4.379698753356934 9.228837013244629 L 7.643089294433594 12.49222755432129 C 7.820768356323242 12.6699275970459 8.063061714172363 12.76770210266113 8.314329147338867 12.76303672790527 C 8.565579414367676 12.75838756561279 8.804119110107422 12.65171813964844 8.975089073181152 12.46756744384766 L 13.89607906341553 6.313247680664062 C 14.23300933837891 5.945697784423828 14.21797943115234 5.377217292785645 13.86208915710449 5.027987480163574 C 13.68234062194824 4.851597785949707 13.44832229614258 4.763197898864746 13.21417427062988 4.763197898864746 M 13.21417903900146 3.763197898864746 C 13.72153854370117 3.763197898864746 14.20037841796875 3.958897590637207 14.5624885559082 4.314237594604492 C 15.29772472381592 5.035710334777832 15.33732318878174 6.190142631530762 14.65969276428223 6.959515571594238 L 9.733058929443359 13.12090682983398 L 9.707939147949219 13.14795684814453 C 9.354059219360352 13.52911758422852 8.852849006652832 13.7532377243042 8.332829475402832 13.76286697387695 C 8.321429252624512 13.76308727264404 8.309259414672852 13.76319694519043 8.297159194946289 13.76319694519043 C 7.782958984375 13.76319694519043 7.299538612365723 13.56293773651123 6.935938835144043 13.19929695129395 L 3.68262767791748 9.945985794067383 C 3.178537368774414 9.465902328491211 2.972633361816406 8.751337051391602 3.145169258117676 8.075777053833008 C 3.319438934326172 7.393407821655273 3.851589202880859 6.861247062683105 4.53395938873291 6.686977386474609 C 4.689518928527832 6.647237777709961 4.84977912902832 6.627087593078613 5.010258674621582 6.627087593078613 C 5.535423278808594 6.627067565917969 6.042234420776367 6.844522476196289 6.404193878173828 7.224447250366211 L 8.179105758666992 8.998514175415039 L 10.51819133758545 6.018257141113281 L 10.07702922821045 6.018257141113281 L 11.88687896728516 4.293997764587402 C 12.24640846252441 3.95170783996582 12.71778869628906 3.763197898864746 13.21417903900146 3.763197898864746 Z",
    stroke: "none",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldZakautChecked);
export default __webpack_public_path__ + "static/media/goldZakautChecked.a79aa7b0e55adf405f5b0bb7ed8441e3.svg";
export { ForwardRef as ReactComponent };